import { RANKS, SUITS } from './constants';
import type { Card, Rank } from './types';

export function rankToValue(rank: Rank): number {
  if (rank === 'A') return 1;
  if (rank === 'J') return 11;
  if (rank === 'Q') return 12;
  if (rank === 'K') return 13;
  return Number(rank);
}

export function cardValue(card: Pick<Card, 'rank'>): number {
  return rankToValue(card.rank);
}

export function isRoyal(card: Pick<Card, 'rank'>): boolean {
  return card.rank === 'J' || card.rank === 'Q' || card.rank === 'K';
}

export function isNumeric(card: Pick<Card, 'rank'>): boolean {
  return !isRoyal(card);
}

export function numericValue(card: Pick<Card, 'rank'>): number {
  return rankToValue(card.rank);
}

export function createShuffledDeck(seed = `${Date.now()}`): Card[] {
  const deck: Card[] = [];
  let index = 0;
  for (const suit of SUITS) {
    for (const rank of RANKS) {
      deck.push({
        id: `${rank}${suit}-${index}`,
        rank,
        suit,
      });
      index += 1;
    }
  }

  return shuffle(deck, seed);
}

export function shuffle(list: Card[], seedText: string): Card[] {
  const deck = [...list];
  let seed = hash(seedText);

  for (let i = deck.length - 1; i > 0; i -= 1) {
    seed = next(seed);
    const j = Math.floor((seed / 0x100000000) * (i + 1));
    [deck[i], deck[j]] = [deck[j], deck[i]];
  }

  return deck;
}

function hash(text: string): number {
  let h = 2166136261;
  for (let i = 0; i < text.length; i += 1) {
    h ^= text.charCodeAt(i);
    h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
  }
  return h >>> 0;
}

function next(value: number): number {
  return (1664525 * value + 1013904223) >>> 0;
}
